/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PortCallsGet200ResponseRecordsInnerPort } from './PortCallsGet200ResponseRecordsInnerPort';
import {
    PortCallsGet200ResponseRecordsInnerPortFromJSON,
    PortCallsGet200ResponseRecordsInnerPortFromJSONTyped,
    PortCallsGet200ResponseRecordsInnerPortToJSON,
} from './PortCallsGet200ResponseRecordsInnerPort';
import type { Ship } from './Ship';
import {
    ShipFromJSON,
    ShipFromJSONTyped,
    ShipToJSON,
} from './Ship';

/**
 * 
 * @export
 * @interface PortCallsGet200ResponseRecordsInner
 */
export interface PortCallsGet200ResponseRecordsInner {
    /**
     * 
     * @type {Ship}
     * @memberof PortCallsGet200ResponseRecordsInner
     */
    ship?: Ship;
    /**
     * 
     * @type {PortCallsGet200ResponseRecordsInnerPort}
     * @memberof PortCallsGet200ResponseRecordsInner
     */
    port?: PortCallsGet200ResponseRecordsInnerPort;
    /**
     * 
     * @type {string}
     * @memberof PortCallsGet200ResponseRecordsInner
     */
    ata?: string;
    /**
     * 
     * @type {string}
     * @memberof PortCallsGet200ResponseRecordsInner
     */
    atd?: string;
}

/**
 * Check if a given object implements the PortCallsGet200ResponseRecordsInner interface.
 */
export function instanceOfPortCallsGet200ResponseRecordsInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PortCallsGet200ResponseRecordsInnerFromJSON(json: any): PortCallsGet200ResponseRecordsInner {
    return PortCallsGet200ResponseRecordsInnerFromJSONTyped(json, false);
}

export function PortCallsGet200ResponseRecordsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortCallsGet200ResponseRecordsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ship': !exists(json, 'ship') ? undefined : ShipFromJSON(json['ship']),
        'port': !exists(json, 'port') ? undefined : PortCallsGet200ResponseRecordsInnerPortFromJSON(json['port']),
        'ata': !exists(json, 'ata') ? undefined : json['ata'],
        'atd': !exists(json, 'atd') ? undefined : json['atd'],
    };
}

export function PortCallsGet200ResponseRecordsInnerToJSON(value?: PortCallsGet200ResponseRecordsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ship': ShipToJSON(value.ship),
        'port': PortCallsGet200ResponseRecordsInnerPortToJSON(value.port),
        'ata': value.ata,
        'atd': value.atd,
    };
}

